import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { findOrganizationClassification } from "../../../_redux/organization-classification/organizationClassificationCrud";
import { findAllOrgRegional } from "../../../_redux/organization-regional/organizationRegionalCrud";
import OrganizationEditDataForm from "./OrganizationEditDataForm";
import { findOrganizationCategory } from "../../../_redux/organization-category/organizationCategoryCrud";

export default function OrganizationEditData({
  show,
  onHide,
  onSubmit,
  initialValues = {}
}) {
  const [options, setOptions] = useState({
    org_classification: [],
    org_regional: [],
    org_category: []
  });
  useEffect(() => {
    if (show) {
      findOptions();
    }
  }, [show]);

  const findOptions = async () => {
    // * Org Classification
    findOrganizationClassification({
      pageNumber: 1,
      pageSize: 10,
      filter: {}
    }).then(res => {
      const {
        data: { data }
      } = res;
      setOptions(prev => ({
        ...prev,
        org_classification: data.items
      }));
    });

    // * Org Regional
    const {
      data: { data: regionalData }
    } = await findAllOrgRegional();
    setOptions(prev => ({
      ...prev,
      org_regional: regionalData
    }));

    // * Org Category
    findOrganizationCategory({
      pageNumber: 1,
      pageSize: 10,
      filter: {}
    }).then(res => {
      const {
        data: { data }
      } = res;
      setOptions(prev => ({
        ...prev,
        org_category: data.items
      }));
    });
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onSubmit(values)}
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header>
              <h4>Edit Data</h4>
            </Modal.Header>
            <Modal.Body>
              <OrganizationEditDataForm
                inputOptions={options}
                setFieldValue={setFieldValue}
                values={values}
              />
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-primary float-right"
                onClick={handleSubmit}
              >
                Simpan
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </>
  );
}
